import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { Alert } from '../../interfaces/alert';
import { ColumnComponentInputs } from '../../interfaces/column-component-inputs';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import { SystemUpdate } from '../../interfaces/system-update';
import { Alerts } from '../../mock-data/alerts';
import { SystemUpdates } from '../../mock-data/system-updates';
import { GridComponent } from '../grid/grid.component';
import {
  GridRoutes,
  gridRoutes,
  DashboardLabels,
  dashboardLabels,
} from '../../constants/constants';
import { StudentProfile } from '../../interfaces/student-profile';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent {
  @Input() title!: string;
  @Input() refershGrid: boolean;
  @Input() columnDefinitions!: ColumnComponentInputs[];
  @Input() expandedRowColumnDefinitions!: ColumnComponentInputs[];
  @Input() gridApiRoute: string;
  @Input() studentSk: string;
  @Input() initialNesteState: State;
  @Input() initialGridState: State;
  @Input() addButtonText: string;
  @Input() permissionToView: number;
  @Input() gridNestedApiRoute: string;
  @Input() referenceData: Record<string, IReferenceData[]>;
  @Output() addToGrid: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild(GridComponent)
  private gridComponent: GridComponent;
  @Input() gridHeader : string;
  alerts: Alert[] = Alerts;
  systemUpdates: SystemUpdate[] = SystemUpdates;
  public gridRoutes: GridRoutes = gridRoutes;
  public dashboardLabels: DashboardLabels = dashboardLabels;
  @Input() studentDetails: StudentProfile;

  reloadData(state: State): void {
    this.gridComponent.reloadGrid(state);
  }
}
